// Lightweight Web Audio SFX + haptics. One toggle controls both ("Sound & Buzz").
import { appSettings } from "./appSettings";
let ctx;
function actx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function isMuted() {
  return localStorage.getItem("mw_muted") === "1";
}
export function setMuted(m) {
  localStorage.setItem("mw_muted", m ? "1" : "0");
}

function tone(freq, dur, type = "sine", vol = 0.18, when = 0) {
  if (isMuted()) return;
  try {
    const a = actx();
    const o = a.createOscillator();
    const g = a.createGain();
    o.type = type;
    o.frequency.value = freq;
    o.connect(g);
    g.connect(a.destination);
    const t = a.currentTime + when;
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0008, t + dur);
    o.start(t);
    o.stop(t + dur);
  } catch {}
}

export function vibrate(pattern) {
  if (isMuted()) return;
  try {
    if (navigator.vibrate) navigator.vibrate(pattern);
  } catch {}
}

export const playClick = () => tone(620, 0.05, "square", 0.06);
export function playSpin() {
  for (let i = 0; i < 10; i++) tone(280 + i * 45, 0.05, "square", 0.05, i * 0.07);
  vibrate(15);
}
export function playDamru() {
  if (isMuted()) return;
  for (let i = 0; i < 14; i++) {
    const hi = i % 2 === 0;
    tone(hi ? 190 : 150, 0.09, "sine", 0.32, i * 0.075);
    tone(hi ? 420 : 360, 0.03, "triangle", 0.06, i * 0.075);
  }
  [880, 1320, 1760].forEach((f, i) => tone(f, 1.6, "sine", 0.07 - i * 0.015, 1.1));
  vibrate([30, 30, 30, 30, 30, 30, 120]);
  try {
    const u = new SpeechSynthesisUtterance("हर हर महादेव");
    u.lang = "hi-IN"; u.rate = 0.95; u.pitch = 0.8;
    setTimeout(() => window.speechSynthesis?.speak(u), 1150);
  } catch {}
}

export function playWin(win = 0) {
  const c = appSettings?.chime;
  if (c?.enabled && win > 0 && win >= Number(c.min_win || 0)) { playDamru(); return; }
  [523, 659, 784, 1047].forEach((f, i) => tone(f, 0.2, "triangle", 0.2, i * 0.09));
  vibrate([25, 40, 70]);
}
export function playLose() {
  tone(210, 0.28, "sawtooth", 0.1);
  tone(150, 0.3, "sawtooth", 0.08, 0.08);
  vibrate(25);
}
export const playScratch = () => tone(110 + Math.random() * 40, 0.12, "sawtooth", 0.05);
export function playReward() {
  [659, 784, 988, 1319].forEach((f, i) => tone(f, 0.18, "triangle", 0.2, i * 0.08));
  vibrate([20, 30, 50]);
}
export function playCrash() {
  tone(420, 0.1, "sawtooth", 0.18);
  tone(190, 0.32, "sawtooth", 0.2, 0.05);
  tone(90, 0.4, "square", 0.14, 0.12);
  vibrate([60, 30, 90]);
}
export const playBlip = (mult) => tone(300 + Math.min(1500, (mult - 1) * 160), 0.045, "triangle", 0.05);
export function playNewRound() {
  tone(660, 0.12, "triangle", 0.12);
  tone(880, 0.16, "triangle", 0.12, 0.1);
}
